import React, { useState } from "react"
import CTA from "../../atoms/CTA"
import "./styles.scss"
const BrandsList = ({ clients, countries, isDesktop }) => {
  const [activeCountry, setActiveCountry] = useState("all")
  const [otherCountry, setOtherCountry] = useState("Other")
  const [loopLimit, setLoopLimit] = useState(10)
  const handleCountry = country => {
    setLoopLimit(10)

    setActiveCountry(country)
  }

  const handleChange = event => {
    setLoopLimit(10)
    setOtherCountry(event.target.value)
    setActiveCountry(event.target.value)
  }

  let filteredClients = 0

  if (isDesktop) {
    return (
      <div className="brands">
        <ul className="brands__navigation">
          {countries.map((country, i) => {
            return (
              <li
                key={i}
                className={` ${country.name !== activeCountry ? "" : "active"}`}
                onClick={() => handleCountry(country.name)}
              >
                {country.name}
              </li>
            )
          })}
        </ul>
        <ul className="brands__list">
          {clients.map((client, i) => {
            return (
              <li
                key={i}
                className={` ${
                  client.country.name !== activeCountry &&
                  activeCountry !== "all"
                    ? ""
                    : "active"
                }`}
              >
                {client.title}
              </li>
            )
          })}
        </ul>
      </div>
    )
  } else {
    return (
      <div className="brandsMobile">
        <div className="brandsMobile__navigation">
          <div className="navigation__left">
            <span
              className={activeCountry === "all" ? "active" : ""}
              onClick={() => handleCountry("all")}
            >
              All
            </span>
            <span
              className={activeCountry === "US" ? "active" : ""}
              onClick={() => handleCountry("US")}
            >
              US
            </span>
          </div>
          <div className="navigation__right">
            <span
              className={`${
                activeCountry === "all" || activeCountry === "US"
                  ? ""
                  : "active"
              }`}
            >
              {activeCountry === "all" || activeCountry === "US"
                ? "Other"
                : activeCountry}
            </span>
            <select
              onChange={e => handleChange(e)}
              value={otherCountry}
              className="countriesSelect"
            >
              {countries.map((country, i) => {
                if (country.name !== "all" && country.name !== "US") {
                  return (
                    <option key={i} value={country.name}>
                      {country.name}
                    </option>
                  )
                } else {
                  return false
                }
              })}
            </select>
          </div>
        </div>
        <ul className="brandsMobile__list">
          {clients.map((client, i) => {
            if (
              client.country.name !== activeCountry &&
              activeCountry !== "all"
            ) {
              return false
            } else {
              filteredClients = filteredClients + 1
              return (
                <li
                  className={filteredClients - 1 < loopLimit ? "animate" : ""}
                  key={i}
                >
                  {client.title}
                </li>
              )
            }
          })}
        </ul>
        <div
          onClick={() => setLoopLimit(loopLimit + 10)}
          className="brandsMobile__more"
        >
          {filteredClients > loopLimit && (
            <CTA className="btn--bordered">Show more</CTA>
          )}
        </div>
      </div>
    )
  }
}

export default BrandsList
